/*
 * One row per medicine in a catalogue search.
 *
 * The search answers from two places - what the pharmacy stocks and what the
 * organisation's master list holds - so a drug in both comes back twice under
 * the same name: once carrying a stock figure, once not. Offered as they
 * arrive they read as two different medicines with identical names, and which
 * of the two gets prescribed is down to which one the cursor lands on.
 *
 * The stocked one wins, because it is the one that can actually be dispensed;
 * the other is dropped rather than shown as a second, identical choice. A row
 * with no name to compare on is left alone - it is not a duplicate of
 * anything, it is a row the search returned oddly.
 */
export const dedupeMedicines = (rows = []) => {
  const byName = new Map();
  const unnamed = [];

  rows.forEach((row) => {
    const key = String(row?.name ?? "").trim().toLowerCase();
    if (!key) {
      unnamed.push(row);
      return;
    }

    const held = byName.get(key);
    if (!held) {
      byName.set(key, row);
      return;
    }

    /* Prefer the one the pharmacy stocks; failing that, the one that at least
       knows its stock level. */
    const better =
      (row?.is_pharmacy_medicine && !held?.is_pharmacy_medicine) ||
      (row?.current_stock != null && held?.current_stock == null);
    if (better) byName.set(key, row);
  });

  return [...byName.values(), ...unnamed];
};

export default dedupeMedicines;
